import React from 'react'
import { StarChartAssignOrganizationPresentationProps } from '../../types/types'
import { DialogContent } from '@mui/material'
import { images } from '../../../../constants'
import { StarChartAssignOrgDialogStyle, StarChartAssignOrgCloseIcon, StarChartAssignOrgFormCol, StarChartAssignOrgTitle, StarChartAssignOrgDesc, StarChartAssignOrgList } from './StarChartAssignOrganizationPresentation.style'
import { SaveButton } from '../../../students/presantation/studentAddPresentation/student.add.presentation'
import StarChartAssignOrganizationItem from './StarChartAssignOrganizationItem'


const StarChartAssignOrganizationPresentation: React.FC<StarChartAssignOrganizationPresentationProps> = ({starChartAssignArg , assignArgPopup}) => {

const list: any[] = [
    "organization1",
    "organization1",
    "organization2",
    "organization3",
    "organization5",
    "organization8",
    "organization9",
    "organization10",
    "organization11",
    "organization12",
    
]

  return (
    <StarChartAssignOrgDialogStyle
    open={starChartAssignArg}
    onClose={assignArgPopup}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogContent sx={{ width: '500px', padding: '24px' }}>

        <StarChartAssignOrgCloseIcon
            onClick={assignArgPopup}
            src={images.closeIconSimple}
                            
        />
        <StarChartAssignOrgFormCol alignment="flex-start" Direction={'column'}>
                <StarChartAssignOrgTitle>Assign an Organization</StarChartAssignOrgTitle>
                <StarChartAssignOrgDesc style={{paddingBottom:15}}>Select organizations to assign to the StarChart</StarChartAssignOrgDesc>
                <StarChartAssignOrgList>
                    {list.map((item) => (
                        <StarChartAssignOrganizationItem
                            organizationName={item}
                            key={item}
            
                        />
                    ))}
                </StarChartAssignOrgList>

        </StarChartAssignOrgFormCol>
        <StarChartAssignOrgFormCol alignment="flex-end" Direction={'row'} style={{width:"100%", paddingTop:15}}>
                  
                        <SaveButton
                          style={{ marginLeft: '15px', width: '70px',backgroundColor:"#34C38F" ,borderRadius:5 , padding:8 }}
                          onClick={assignArgPopup}
                        >
                          Save
            
                          
                        </SaveButton>

        </StarChartAssignOrgFormCol>


      </DialogContent>
    </StarChartAssignOrgDialogStyle>


  )
}

export default StarChartAssignOrganizationPresentation